module.exports = __webpack_public_path__ + "static/media/Korean-sentence-structure.8e905f96.jpg";